import { create } from 'zustand'

// ============================================================================
// Types
// ============================================================================

interface TenantManagementState {
  // Selected tenant
  selectedTenantId: string | null
  setSelectedTenantId: (id: string | null) => void

  // Modal states
  isCreateModalOpen: boolean
  setCreateModalOpen: (open: boolean) => void

  isSuspensionModalOpen: boolean
  setSuspensionModalOpen: (open: boolean) => void

  isQuotaEditorOpen: boolean
  setQuotaEditorOpen: (open: boolean) => void

  // Usage history settings
  usageHistoryDays: number
  setUsageHistoryDays: (days: number) => void
}

// ============================================================================
// Store
// ============================================================================

/**
 * Screen state for tenant management: what is selected, what is open, what the usage chart spans.
 *
 * The list's filters, sort and pagination are NOT here — they live in `tenantFiltersStore`, built
 * from `createTableFiltersStore`, which also caches them in sessionStorage and owns the "any filter
 * change returns to page 1" rule. Nothing in this store is worth surviving a reload: a modal that
 * reopens itself is a bug, not a convenience.
 */
export const useTenantManagementStore = create<TenantManagementState>((set) => ({
  // Selected tenant
  selectedTenantId: null,
  setSelectedTenantId: (id) => set({ selectedTenantId: id }),

  // Modal states
  isCreateModalOpen: false,
  setCreateModalOpen: (open) => set({ isCreateModalOpen: open }),

  isSuspensionModalOpen: false,
  setSuspensionModalOpen: (open) => set({ isSuspensionModalOpen: open }),

  isQuotaEditorOpen: false,
  setQuotaEditorOpen: (open) => set({ isQuotaEditorOpen: open }),

  // Usage history settings
  usageHistoryDays: 30,
  setUsageHistoryDays: (days) => set({ usageHistoryDays: days }),
}))
